import {Service} from "../Service";
import {NativeArchivoDto} from "../dto/archivo/NativeArchivoDto";

export class ArchivoService extends Service {
    constructor() {
        super('archivos/');
    }

    seleccionarArchivoYEnviar(fileNative, url, paciente) {
        const archivoDto = new NativeArchivoDto(fileNative);
        const blob = new Blob([fileNative], {type: archivoDto.type});

        if (archivoDto.name.length > 40) {
            this.toast.info('El nombre del archivo es demasiado largo. Máximo 40 carácteres.');
            return 0
        }
        const formData = new FormData();
        formData.append("archivo", blob, archivoDto.name);
        formData.append("idUsuario", this.localStorage.getIdUsuario());
        formData.append("nombre", archivoDto.name);
        formData.append("ext", archivoDto.name.split('.').pop());
        formData.append("mime", archivoDto.type);
        formData.append("url", url);
        formData.append("idPaciente", paciente)

        return this.enviarArchivo(formData)
    }

    enviarArchivo(formData) {
        this.onStart();
        const config = {
            header: {
                "Content-Type": "image/png",
            },
        };
        return this.http.post(this.getUrl(['guardar']), formData, config)
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    getArchivoConBase64(idArchivo){
        return this.http.get(this.getUrl(['obtener','base64'],{idArchivo}))
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    getArchivoSinBase64(idArchivo){
        return this.http.get(this.getUrl(['obtener'],{idArchivo}))
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    descargar(idArchivo) {
        this.getArchivoConBase64(idArchivo).then((archivo) => {
            this.dataURLtoFile(archivo);
        })
    }

    archivoConbase64ToDataUrl(archivo) {
        return 'data:' + archivo.mime + ';base64,'+archivo.base64;
    }
    dataURLtoFile(archivo) {
        var a = document.createElement("a"); //Create <a>
        a.href = this.archivoConbase64ToDataUrl(archivo) //Image Base64 Goes here
        a.download = archivo.nombre; //File name Here
        a.click(); //Downloaded file
    }

    seleccionarArchivoBase64(dataURL) {
        var blob = this.dataURLtoBlob(dataURL);

            const formData = new FormData();
            formData.append("archivo", blob);
        return this.enviarArchivo(formData)
    }



    dataURLtoBlob(dataURL) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURL.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        //New Code
        return new Blob([ab], {type: mimeString});
    }
}
